import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataDetalhesPedidoReducer } from "../reducers";
import { InitialStateDetalhesPedido } from "./model";

const initialState: InitialStateDetalhesPedido = {
  items: [],
  requestGetParams: {},
};

const detalhesPedidoSlice = createSlice({
  name: "matrizConfigApp/detalhesPedido",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      Actions.getMatrizCampos.fulfilled,
      dataDetalhesPedidoReducer
    );
    builder.addCase(
      Actions.getDetalhesById.fulfilled,
      dataDetalhesPedidoReducer
    );
  },
});

export default detalhesPedidoSlice.reducer;
